import { MapContainer, TileLayer, Marker, Popup, CircleMarker } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { useEffect } from "react";

// Fix default marker icons (webpack quirk)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

// Custom gold divIcon
const goldIcon = L.divIcon({
  className: "pp-marker",
  html: '<span style="display:block;width:18px;height:18px;background:#001588;border:3px solid #050d19;border-radius:50%;box-shadow:0 2px 8px rgba(0,0,0,.4)"></span>',
  iconSize: [18, 18], iconAnchor: [9, 9],
});

// Fallback community centroid map (public Dubai coordinates)
const COMMUNITY_CENTROIDS = {
  "downtown dubai": [25.1945, 55.2743],
  "palm jumeirah": [25.1123, 55.1385],
  "dubai marina": [25.0819, 55.1439],
  "business bay": [25.1855, 55.2635],
  "difc": [25.2149, 55.2802],
  "mbr city": [25.1584, 55.2965],
  "jvc": [25.0510, 55.2076],
};

export function communityCoords(name) {
  if (!name) return null;
  return COMMUNITY_CENTROIDS[name.toLowerCase()] || null;
}

// Point marker map (used by PropertyDetail)
export function PropertyMap({ lat, lng, community, title, height = 360 }) {
  const c = (lat && lng) ? [lat, lng] : communityCoords(community);
  if (!c) return <div className="border border-neutral-200 p-6 text-sm text-neutral-500">Location coming soon.</div>;
  return (
    <div style={{ height }} className="border border-neutral-200 overflow-hidden" data-testid="property-map">
      <MapContainer center={c} zoom={15} scrollWheelZoom={false} style={{ height: "100%", width: "100%" }}>
        <TileLayer
          attribution='&copy; <a href="https://carto.com/">CARTO</a>'
          url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
        />
        <Marker position={c} icon={goldIcon}>
          <Popup>{title || community}</Popup>
        </Marker>
      </MapContainer>
    </div>
  );
}

// Community map with POI markers
export function CommunityMap({ community, pois = [], height = 460 }) {
  const c = communityCoords(community);
  if (!c) return null;
  return (
    <div style={{ height }} className="border border-neutral-200 overflow-hidden" data-testid="community-map">
      <MapContainer center={c} zoom={14} scrollWheelZoom={false} style={{ height: "100%", width: "100%" }}>
        <TileLayer
          attribution='&copy; <a href="https://carto.com/">CARTO</a>'
          url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
        />
        <Marker position={c} icon={goldIcon}>
          <Popup>{community}</Popup>
        </Marker>
        {pois.map((p, i) => (
          <PoiPin key={i} p={p} />
        ))}
      </MapContainer>
    </div>
  );
}

const CATEGORY_COLORS = {
  school: "#3B82F6", hospital: "#EF4444", metro: "#10B981",
  mall: "#F59E0B", landmark: "#001588", airport: "#8B5CF6",
};

function PoiPin({ p }) {
  const color = CATEGORY_COLORS[p.category] || "#001588";
  return (
    <CircleMarker
      center={[p.lat, p.lng]} radius={8} color={color} fillColor={color} fillOpacity={0.85} weight={2}
    >
      <Popup>
        <div className="font-medium">{p.name}</div>
        <div className="text-xs uppercase text-gray-500">{p.category}</div>
      </Popup>
    </CircleMarker>
  );
}
